import React from 'react';

import { useQuery } from '@apollo/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import Loading from 'components/Loading/Loading';

import candidateSchema from '../../../../services/candidate/gqlSchema';
import CandidateCardContractForm from './Contract/Form';
import CandidateCardContractPending from './Contract/Pending';
import CandidateCardContractSigned from './Contract/Signed';

const CandidateCardContract = ({ tabInfos, contact, signature }) => {
  const contactInfo = contact.contactsInfos.find(infos => infos.sources && infos.sources.source === 'SALESFORCE');

  const { data, loading } = useQuery(candidateSchema.Query.transactionInfo, {
    variables: {
      signUuid: signature?.signUuid,
    },
  });

  const dataTransactionInfo = data?.transactionInfo;

  if (loading) {
    return <Loading type={Loading.TYPE.MATERIAL} name={'linear'} />;
  }

  return (
    <Box>
      <FontAwesomeIcon icon={tabInfos.icon} />
      <Box component='span' sx={{ marginLeft: '5px', fontSize: '1rem', fontWeight: '700', textTransform: 'uppercase' }}>
        {tabInfos.title}
      </Box>
      <Box sx={{ paddingTop: '30px' }}>
        {signature ? (
          dataTransactionInfo?.signerInfos[0].status === 'ready' ? (
            <CandidateCardContractPending contact={contact} dataSignaturesByContact={signature} />
          ) : dataTransactionInfo?.signerInfos[0].status === 'signed' ? (
            <CandidateCardContractSigned
              dataSignaturesByContact={signature}
              signerInfos={dataTransactionInfo?.signerInfos[0]}
              contactInfo={contactInfo}
            />
          ) : (
            <CandidateCardContractForm contact={contact} />
          )
        ) : (
          <CandidateCardContractForm contact={contact} />
        )}
      </Box>
    </Box>
  );
};

export default React.memo(CandidateCardContract);
